import { Component, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription, filter } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnDestroy {

  title = 'BesselAI';

  private sub!: Subscription;

  constructor(private router: Router) {

    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe(() => {

        setTimeout(() => {

          const lenis = (window as any).LenisScroll?.lenis;

          if (lenis && typeof lenis.scrollTo === 'function') {
            lenis.scrollTo(0, { immediate: true });
          }

          (window as any).initTemplate?.();
          (window as any).ScrollTrigger?.refresh();

        }, 0);

      });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }
}
